import { Box, Button } from '@mui/material';
import { ReactNode } from 'react';

interface StepNavigationProps {
  onPrevious?: () => void;
  onNext: () => void;
  nextLabel: string;
  previousLabel?: string;
  disableNext?: boolean;
  disablePrevious?: boolean;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  onSecondary?: () => void;
  secondaryLabel?: string;
  secondaryDisabled?: boolean;
}

export const StepNavigation = ({
  onPrevious,
  onNext,
  nextLabel,
  previousLabel = 'Previous',
  disableNext = false,
  disablePrevious = false,
  startAdornment,
  endAdornment,
  onSecondary,
  secondaryLabel,
  secondaryDisabled = false,
}: StepNavigationProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 3,
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {startAdornment}
        {onPrevious ? (
          <Button
            variant="outlined"
            onClick={onPrevious}
            disabled={disablePrevious}
            data-testid="step-previous-button"
          >
            {previousLabel}
          </Button>
        ) : null}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {endAdornment}
        <Button
          variant="contained"
          onClick={onNext}
          disabled={disableNext}
          data-testid="step-next-button"
        >
          {nextLabel}
        </Button>
        {secondaryLabel && onSecondary ? (
          <Button
            variant="contained"
            color="success"
            onClick={onSecondary}
            disabled={secondaryDisabled}
            data-testid="secondary-step-button"
          >
            {secondaryLabel}
          </Button>
        ) : null}
      </Box>
    </Box>
  );
};
